import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Link, Redirect } from "react-router-dom";
import Dropzone from 'react-dropzone';

import * as ActionTypes from '../actions';

import Alert from '../components/Alert';
import Button from '../components/Button';
import Card from '../components/Card';
import Fieldset from '../components/Fieldset';
import Form from '../components/Form';
import FormGroup from '../components/FormGroup';
import Heading from '../components/Heading';
import Input from '../components/Input';
import Legend from '../components/Legend';
import LoadingSpinner from '../components/LoadingSpinner';
import Pagination from '../components/Pagination';
import PaginationPrev from '../components/PaginationPrev';
import PaginationNext from '../components/PaginationNext';
import Textarea from '../components/Textarea';

const mapStateToProps = (state) => {
    return {
        data: state.data,
        isLoading: state.isLoading
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateData: (data) => dispatch(ActionTypes.updateData(data)),
        uploadFileToData: (file, fileName) => dispatch(ActionTypes.uploadFileToData(file, fileName))
    };
};

class Checkout extends Component {

    constructor(props) {
        super(props);
        this.inputRefs = [];

        const {data} = props;

        this.state = {
            isValidated: false,
            isSubmitted: false,
            isBilledToCompany: data["is_billed_to_company"] ? true : false
        };
    }

    validate = () => {
        let isValidated = true;

        for (const [key, value] of Object.entries(this.inputRefs)) {
            if (value.required) {
                if (value.value) {
                    value.classList.remove('is-invalid');
                }
                else {
                    isValidated = false;
                    value.classList.add('is-invalid');
                }
            }
        }

        this.setState({
            isValidated: isValidated,
            isSubmitted: true
        });

        return isValidated;
    }

    handleSetIsBilledToCompany = event => {
        this.setState({
           isBilledToCompany: event.target.checked
        });
    }

    handleUpdateData = event => {
        event.preventDefault();

        const isValidated = this.validate();

        if (isValidated) {
            const data = new Object();

            for (const [key, value] of Object.entries(this.inputRefs)) {
                data[key] = value.type === 'checkbox' ? value.checked : value.value;
            }

            this.props.updateData(data);
        }
    }

    componentDidMount() {
        const {data} = this.props;

        for (const [key, value] of Object.entries(this.inputRefs)) {
            if (data[key]) {
                value.value = data[key];
            }
        }
    }

    componentDidUpdate(prevProps) {
        const prevData = prevProps.data;
        const {data} = this.props;
        const {isBilledToCompany} = this.state;

        if (data != prevData) {
            this.setState({
                isBilledToCompany: data["is_billed_to_company"] ? true : isBilledToCompany
            });


        } else {
            for (const [key, value] of Object.entries(this.inputRefs)) {
                if (data[key]) {
                    if(value) value.value = data[key];
                }
            }
        }
    }

    handleUploadFile = acceptedFiles => {
        let file;
        let fileName;

        const reader = new FileReader();

        acceptedFiles.forEach(acceptedFile => {
            reader.readAsDataURL(acceptedFile);
            reader.onload = () => {
                file = reader.result;
                fileName = acceptedFile.name;

                this.props.uploadFileToData(file, fileName);
            }
        });
    }

    render() {
        const {data, isLoading} = this.props;
        const files = data.files;
        const {isSubmitted, isValidated, isBilledToCompany} = this.state;

        return (
            <div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        {isSubmitted && isValidated ? (
                            <Redirect to="/summary" />
                        ) : (
                            <div>
                                <Heading>Anmeldung</Heading>
                                <Form>
                                    <Card>
                                        <Fieldset>
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input form-control" name="isBilledToCompany" id="cart_isBilledToCompany" ref={node => this.inputRefs["is_billed_to_company"] = node} onChange={this.handleSetIsBilledToCompany} checked={isBilledToCompany} value="1" />
                                                <label class="custom-control-label" for="cart_isBilledToCompany">Abweichender Rechnungsempfänger</label>
                                            </div>
                                        </Fieldset>

                                        <Fieldset style={isBilledToCompany ? {display: "none"} : {}}>
                                            <Legend>Rechnungsadresse</Legend>
                                            <p>
                                                Die Rechnung wird direkt an die Teilnehmer verschickt.
                                            </p>
                                        </Fieldset>

                                        <Fieldset style={isBilledToCompany ? {} : {display: "none"}}>
                                            <Legend>Rechnungsadresse</Legend>
                                            <p>
                                                Bei einer abweichenden Rechnungsadresse müssen Sie uns unbedingt das entsprechende Kostenübernahme-Formular unterschrieben zukommen lassen.
                                            </p>
                                            <FormGroup label="Unternehmen">
                                                <Input inputRef={node => this.inputRefs["bill_company"] = node} name="bill_company" />
                                            </FormGroup>
                                            <FormGroup label="Straße, Hsnr." required="1">
                                                <Input inputRef={node => this.inputRefs["bill_street"] = node} name="bill_street" required={isBilledToCompany} />
                                            </FormGroup>
                                            <FormGroup label="PLZ" required="1">
                                                <Input inputRef={node => this.inputRefs["bill_zip"] = node} name="bill_zip" required={isBilledToCompany} />
                                            </FormGroup>
                                            <FormGroup label="Ort" required="1">
                                                <Input inputRef={node => this.inputRefs["bill_city"] = node} name="bill_city" required={isBilledToCompany} />
                                            </FormGroup>
                                            <FormGroup label="Telefon" required="1">
                                                <Input inputRef={node => this.inputRefs["bill_phone"] = node} name="bill_phone" required={isBilledToCompany} />
                                            </FormGroup>
                                            <FormGroup label="E-Mail" required="1">
                                                <Input inputRef={node => this.inputRefs["bill_emailAddress"] = node} name="bill_emailAddress" required={isBilledToCompany} />
                                            </FormGroup>
                                            <FormGroup label="Kostenübernahme-Formular" required="1">
                                                <Dropzone onDrop={this.handleUploadFile}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section>
                                                            <div class="form-control" {...getRootProps()}>
                                                                <input {...getInputProps()} />
                                                                <p>Dateien hier ablegen …</p>
                                                            </div>
                                                            {files && Object.entries(files).map(([key, value]) => (
                                                                <div className="my-0_25 file">{key}</div>
                                                            ))}
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </FormGroup>
                                        </Fieldset>
                                    </Card>

                                    <Card>
                                        <Fieldset>
                                            <Legend>Ansprechpartner bei Rückfragen</Legend>
                                            <FormGroup label="Name">
                                                <Input inputRef={node => this.inputRefs["altContact_name"] = node} name="altContact_name" />
                                            </FormGroup>
                                            <FormGroup label="Telefon">
                                                <Input inputRef={node => this.inputRefs["altContact_phone"] = node} name="altContact_phone" />
                                            </FormGroup>
                                            <FormGroup label="E-Mail">
                                                <Input inputRef={node => this.inputRefs["altContact_emailAddress"] = node} name="altContact_emailAddress" />
                                            </FormGroup>
                                        </Fieldset>
                                    </Card>

                                    <Card>
                                        <Fieldset>
                                            <Legend>Weitere Informationen</Legend>
                                            <FormGroup label="Anmerkungen" >
                                                 <div className='kicker'>Haben Sie Fragen oder sind für einen Rabatt berechtigt?</div>
                                                <Textarea inputRef={node => this.inputRefs["more_generalInformation"] = node} name="more_generalInformation" />
                                            </FormGroup>
                                        </Fieldset>
                                    </Card>
                                </Form>
                                <Pagination>
                                    <PaginationPrev>
                                        <Link to="/" className="btn btn-gray">Zurück</Link>
                                    </PaginationPrev>
                                    <PaginationNext>
                                        <Button type="button" onClick={this.handleUpdateData}>Zur Zusammenfassung</Button>
                                    </PaginationNext>
                                </Pagination>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
